// What? Neutral node shape consumed by the StructureNavigator widget.
// Why? The two views that show document structure store it differently
//      (DocumentTypeSection uses a ParentSectionID pointer, GenerationSection
//      uses a numeric heading level). Normalising to one shape keeps the
//      widget free of any Meridian data model.
// How? Each view maps its own sections through an adapter in buildNavTree.ts.

/**
 * Attribute marking a scroll target for the navigator.
 *
 * Deliberately distinct from GenerationView's `data-section-id`, which the
 * source-verification subsystem already queries for height tracking, click
 * delegation and citation highlighting. Navigation anchors need to sit on
 * elements that logic must not treat as citation containers, so they get their
 * own attribute rather than overloading that one.
 */
export const NAV_SECTION_ATTR = "data-nav-section-id";

export interface StructureNavNode {
  /** Matches the section element's data-nav-section-id attribute. */
  id: string;
  title: string;
  children: StructureNavNode[];
}
